import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { confirmDialog } from 'app/components/global';

import editAssessmentDocumentDialog from '../dialog.editAssessmentDocumentDialog';
import performAssessmentDialog from '../dialog.performAssessmentDialog';
import assessmentDocument from '../assessmentDocument';

import controller from './completed-assessment.controller';
import directive from './completed-assessment.directive';


export default angular.module('app.components.advisory.ecat.completedAssessment', [
  confirmDialog,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  editAssessmentDocumentDialog,
  performAssessmentDialog,
  assessmentDocument,
  ssDialogService,
  userService,
])
  .directive('ecatCompletedAssessment', directive)
  .controller('ECATCompletedAssessmentController', controller)
  .name;

console.log('app.components.advisory.ecat.completedAssessment created');
